import { parsePath, addPrefixes } from '@st/i18n-base/utils'

/**
 * Автоматически добавляет префиксы платформы/локали при переходах
 * /casino => /ru/mobile/casino
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.path === from.path) return undefined

  const { locale, platform } = parsePath(from.path)

  const prefixedTo = addPrefixes(to.fullPath, { locale, platform })

  if (prefixedTo === to.fullPath) return undefined

  return navigateTo(prefixedTo)
})
